var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"set-up"},[_c('SetUpHeaderCmp'),_c('SetUpSideBarCmp',{attrs:{"clientH":_vm.clientH}}),_c('router-view',{style:({ height: _vm.contentH + 'px' }),attrs:{"clientH":_vm.clientH}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }